import { render, staticRenderFns } from "./ViewHouse.vue?vue&type=template&id=1fa42bfe&scoped=true"
import script from "./ViewHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHouse.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa42bfe",
  null
  
)

export default component.exports